import { RobotsMeta } from "@/components/seo/RobotsMeta";

/**
 * On non-production domains (anything other than zooi.se),
 * inject noindex + nofollow to prevent search engines from indexing
 * staging / preview / lovable.app versions of the site.
 */
const NonProductionNoIndex = () => {
  const isProduction =
    typeof window !== "undefined" &&
    window.location.hostname === "zooi.se";

  if (isProduction) return null;

  return <RobotsMeta policy="noindex-nofollow" />;
};

export default NonProductionNoIndex;
